import React, { useEffect, useRef, useState } from 'react';
// import './BannerBalls.css';

const BannerBalls = () => {
  const [balls, setBalls] = useState([]);
  const animationRefs = useRef([]);

  const colors = ['#ffbe18', '#ddd', '#45f882', '#ffbe18', '#45f882'];
  const numBalls = 30;

  // Создаем начальное состояние шаров
  useEffect(() => {
    const initialBalls = Array.from({ length: numBalls }, (_, i) => ({
      id: i,
      background: colors[Math.floor(Math.random() * colors.length)],
      left: `${Math.floor(Math.random() * 100)}vw`,
      top: `${Math.floor(Math.random() * 100)}vh`,
      scale: Math.random(),
      size: `${Math.random()}em`,
    }));
    setBalls(initialBalls);
  }, []);

  // Анимируем шары после рендера
  useEffect(() => {
    const ballElements = document.querySelectorAll('.banner-area .ball');

    ballElements.forEach((ball, i) => {
      const to = {
        x: Math.random() * (i % 2 === 0 ? -11 : 11),
        y: Math.random() * 12,
      };

      const anim = ball.animate([{ transform: 'translate(0, 0)' }, { transform: `translate(${to.x}rem, ${to.y}rem)` }], {
        duration: (Math.random() + 1) * 2000,
        direction: 'alternate',
        fill: 'both',
        iterations: Infinity,
        easing: 'ease-in-out',
      });

      animationRefs.current.push(anim);
    });

    return () => {
      animationRefs.current.forEach((anim) => anim.cancel());
      animationRefs.current = [];
    };
  }, [balls]);

  return (
    <section className="banner-area">
      {balls.map((ball) => (
        <div
          key={ball.id}
          className="ball"
          style={{
            background: ball.background,
            left: ball.left,
            top: ball.top,
            transform: `scale(${ball.scale})`,
            width: ball.size,
            height: ball.size,
          }}
        />
      ))}
    </section>
  );
};

export default BannerBalls;
